/**
 * MP-6 (F324, Paket P3): „Revit-Import (Engine)“ in der Modellzeile.
 *
 * Art 161 `EngineAufnahme` liest eine hochgeladene RVT-Datei ohne Revit auf einer BIM-Maschine und führt sie in den
 * BIM-Kern des Projekts (bisher nur über den Serverbefehl `auftrag-anlegen`). Die Plattform nimmt den Auftrag nur mit
 * dem Schalter `Bim:EngineEingang` an; das meldet der Server als Fähigkeit (`ProjektDetail.engineEingang`). Die
 * Oberfläche rät den Schalter nicht: ohne das Feld (älterer Server) oder mit `false` gibt es den Knopf nicht.
 *
 * Der Server verlangt außerdem ein Modell aus dem Objektspeicher (Quelle Datei mit abgelegter Datei); ein ACC-Modell
 * kann die Engine (noch) nicht laden. Der Knopf steht dann da, ist aber gesperrt und sagt warum.
 */
import type { Modell } from './api';
import type { Exportaktion } from './ifcDatenkern';

/** ExportKind.EngineAufnahme (Server, `ExportKind.cs`). */
export const ART_ENGINE_AUFNAHME = 161;

/** ModelSource.ObjectStorage (Server, `ModelSource.cs`). */
const QUELLE_OBJEKTSPEICHER = 1;

/** Die Aktion „Revit-Import (Engine)“, nur wenn der Server den Schalter meldet. */
export function engineAktion(engineEingang: boolean | undefined): Exportaktion | null {
  if (engineEingang !== true) return null;
  return {
    art: ART_ENGINE_AUFNAHME,
    name: 'Revit-Import (Engine)',
    titel: 'Revit-Import (Engine): die hochgeladene RVT-Datei ohne Revit in den BIM-Kern des Projekts lesen',
  };
}

/** Warum die Engine dieses Modell nicht lesen kann; null = sie kann. */
export function engineHindernis(modell: Pick<Modell, 'source' | 'storageKey'>): string | null {
  if (modell.source !== QUELLE_OBJEKTSPEICHER || !modell.storageKey) {
    return 'Die Engine liest nur ein hochgeladenes Modell (Datei im Objektspeicher), kein ACC-Modell.';
  }
  return null;
}
